import { VideoTopic } from '~/types/bootcamp'
import ROUTES from '~/shared/constants/routes.const'
import BootcampTopicsOverview from '~/shared/components/BootcampTopicsOverview'
import SelectToggle, { Tab } from '~/curriculum/components/SelectToggle'
import useGetGradePageRoute from '~/dashboard/hooks/useGetGradePageRoute'

const VideoTopicList = ({ topicListData }: { topicListData: VideoTopic[] }): React.ReactElement => {
  const gradeUrl = useGetGradePageRoute()

  return (
    <>
      <div className="mb-3">
        <SelectToggle defaultTab={Tab.TOPIC} gradeUrl={gradeUrl} topicUrl={ROUTES.BOOTCAMP} />
      </div>
      <BootcampTopicsOverview searchToPath topicListData={topicListData} />
    </>
  )
}

export default VideoTopicList
